export const TEXT_ON_TABLE = {
    ZERO: '0',
    DOUBLE_ZERO: '00',
    FIRST_DOZEN: '1ST DOZEN',
    SECOND_DOZEN: '2ND DOZEN',
    THIRD_DOZEN: '3RD DOZEN',
    FIRST_DOZEN_SHORT: '1ST12',
    SECOND_DOZEN_SHORT: '2ND12',
    THIRD_DOZEN_SHORT: '3RD12',
    FIRST_COLUMN: '1ST COLUMN',
    SECOND_COLUMN: '2ND COLUMN',
    THIRD_COLUMN: '3RD COLUMN',
    COLUMN: '2TO1',
    LOW: '1-18',
    EVEN: 'EVEN',
    ODD: 'ODD',
    HIGH: '19-36',
    TIERS: 'TIERS',
    ORPHELINS: 'ORPHELINS',
    ORPHELINS_SHORT: 'ORPH.',
    VOISINS: 'VOISINS',
    ZERO_FRENCH: 'ZERO',
};
